import { render, staticRenderFns } from "./add_h5.vue?vue&type=template&id=2624d9ac&scoped=true&"
import script from "./add_h5.vue?vue&type=script&lang=js&"
export * from "./add_h5.vue?vue&type=script&lang=js&"
import style0 from "./add_h5.vue?vue&type=style&index=0&id=2624d9ac&lang=less&scoped=true&"
import style1 from "./add_h5.vue?vue&type=style&index=1&id=2624d9ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2624d9ac",
  null
  
)

export default component.exports